import React from 'react';
import { Link } from 'react-router-dom';

const CabServices = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Cab Services</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Reliable & Comfortable Cab Services with Rajkuruma</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        At Rajkuruma, we provide safe, reliable, and affordable cab services for every travel need. Whether you're commuting within the city, planning a business trip, or traveling with family, our well-maintained fleet and experienced drivers ensure a smooth journey.
                    </p>
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg mb-16 border-l-8 border-[#f15a24]">
                    <h3 className="text-3xl font-bold mb-6">Why Choose Rajkuruma?</h3>
                    <ul className="grid md:grid-cols-3 gap-4 text-gray-700">
                        {['24/7 Cab Availability', 'Professional & Verified Drivers', 'Clean, Sanitized Vehicles', 'Affordable & Transparent Pricing', 'Instant Booking', 'Comfortable Sedan, SUV & Premium Cars'].map((item, i) => (
                            <li key={i} className="flex items-center font-medium">✅ {item}</li>
                        ))}
                    </ul>
                </div>

                {/* Detailed Services Grid */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <ServiceCard
                        title="Airport Transfers"
                        features={['On-Time Pickup & Drop', 'Flight Tracking Support', 'Meet & Greet Service', '24/7 Airport Taxi']}
                        desc="Hassle-Free Airport Pickup & Drop Services. Never worry about missing a flight."
                    />
                    <ServiceCard
                        title="Corporate Travel"
                        features={['Executive & VIP Transportation', 'Monthly Billing Options', 'Dedicated Business Support', 'GST Invoice Available']}
                        desc="Professional Transportation for Businesses. Reliable solutions for executive meetings and employee transport."
                    />
                    <ServiceCard
                        title="City Tours"
                        features={['Full-Day & Half-Day Tours', 'Popular Tourist Attractions', 'Shopping & Food Tours', 'Experienced Local Drivers']}
                        desc="Explore the city's beauty and culture with customized tour packages at your own pace."
                    />
                    <ServiceCard
                        title="Long Distance Travel"
                        features={['One-Way & Round Trips', 'Multi-Day Tours', 'Interstate Travel', 'Comfortable AC Vehicles']}
                        desc="Planning an outstation trip? Dependable long-distance services for vacations and family visits."
                    />
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#0c24da] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Ready to Ride?</h3>
                    <p className="mb-8">Your trusted travel partner for safe, comfortable, and memorable rides.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">BOOK SERVICE →</Link>
                </div>
            </div>
        </div>
    );
};

const ServiceCard = ({ title, features, desc }) => (
    <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition">
        <h4 className="text-2xl font-bold text-[#0c24da] mb-3">{title}</h4>
        <p className="text-gray-600 mb-4">{desc}</p>
        <ul className="space-y-2">
            {features.map((f, i) => <li key={i} className="text-sm text-gray-500 italic">▸ {f}</li>)}
        </ul>
    </div>
);

export default CabServices;